export const FLASH_SALE_TEXT = 'FLASH_DEAL';
export const MEGA_SAVINGS_TEXT = 'CRAZY_DEAL';
export const NYKAA_EXCLUSIVE_TEXT = 'NYKAA_EXCLUSIVE_DEAL';